export default __webpack_public_path__ + "static/media/logoCenter.c33bf429.png";